var _defs, _g, _g2, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceCr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "46mm",
    height: "46mm",
    viewBox: "0 0 130.3937 130.3937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.d,.e,.i,.j,.n,.o,.p{fill:none;}.b{fill:#54ef9a;}.c,.d,.e,.o{stroke:#ff9376;}.c,.d,.e{stroke-linecap:round;stroke-linejoin:round;}.c,.p{stroke-width:2px;}.d{stroke-width:1.5px;}.e{stroke-width:0.5px;}.f{clip-path:url(#a);}.g{fill:#009b88;}.h{opacity:0.8;fill:url(#b);}.i{stroke:#004743;}.i,.j,.o,.p{stroke-miterlimit:10;}.i,.n{stroke-width:12px;}.j{stroke:#54ef9a;}.j,.o{stroke-width:8px;}.k{clip-path:url(#c);}.l{fill:#db004f;}.m{opacity:0.7;fill:url(#d);}.n,.p{stroke:#7a0032;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: -22.3645,
    y: 10.3862,
    width: 129.7161,
    height: 64.2147,
    transform: "translate(-17.6014 42.4935) rotate(-45)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "b",
    width: 106.7528,
    height: 106.7528,
    patternTransform: "translate(150.2384 374.6969) rotate(-45)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 106.753 106.753"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106.7528,
    height: 106.7528
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.762,111.9759a5.218,5.218,0,1,1,5.2178-5.2183A5.2239,5.2239,0,0,1,107.762,111.9759Zm0-9.936a4.718,4.718,0,1,0,4.7178,4.7177A4.7228,4.7228,0,0,0,107.762,102.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.7622,111.9759a5.218,5.218,0,1,1,5.2178-5.2183A5.224,5.224,0,0,1,107.7622,111.9759Zm0-9.936a4.718,4.718,0,1,0,4.7178,4.7177A4.7229,4.7229,0,0,0,107.7622,102.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0093,111.9759a5.218,5.218,0,0,1,0-10.436,5.218,5.218,0,0,1,0,10.436Zm0-9.936a4.718,4.718,0,0,0,0,9.436,4.718,4.718,0,0,0,0-9.436Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.7583,109.9857a4.2278,4.2278,0,1,1,4.2275-4.2281A4.2327,4.2327,0,0,1,22.7583,109.9857Zm0-8.2056a3.9778,3.9778,0,1,0,3.9775,3.9775A3.9827,3.9827,0,0,0,22.7583,101.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.3865,
    cy: 105.7579,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.5259,111.6024a4.845,4.845,0,1,1,4.3467-2.69A4.8213,4.8213,0,0,1,85.5259,111.6024Zm-1.9239-.9532a4.3442,4.3442,0,1,0-2.1865-2.5063A4.3511,4.3511,0,0,0,83.602,110.6492Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.5338,
    cy: 105.2848,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 68.0472,
    cy: 107.1401,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.9321,111.65a4.0261,4.0261,0,1,1,4.0264-4.0259A4.031,4.031,0,0,1,67.9321,111.65Zm0-7.8022a3.7761,3.7761,0,1,0,3.7764,3.7763A3.7806,3.7806,0,0,0,67.9321,103.848Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.6773,
    cy: 106.7579,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.01,111.9759a5.218,5.218,0,0,1,0-10.436,5.218,5.218,0,0,1,0,10.436Zm0-9.936a4.718,4.718,0,0,0,0,9.436,4.718,4.718,0,0,0,0-9.436Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.762,5.2231A5.2239,5.2239,0,0,1,102.5443.0049a5.2178,5.2178,0,1,1,10.4355,0A5.2239,5.2239,0,0,1,107.762,5.2231Zm0-9.936A4.7229,4.7229,0,0,0,103.0443.0049a4.7233,4.7233,0,0,0,4.7177,4.7182A4.7233,4.7233,0,0,0,112.48.0049,4.7229,4.7229,0,0,0,107.762-4.7129Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: -0.5907,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.762,111.9756a5.2178,5.2178,0,1,1,5.2178-5.2178A5.2238,5.2238,0,0,1,107.762,111.9756Zm0-9.9356a4.7178,4.7178,0,1,0,4.7178,4.7178A4.7229,4.7229,0,0,0,107.762,102.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.7435,91.7251a5.2178,5.2178,0,1,1,5.2178-5.2178A5.2238,5.2238,0,0,1,105.7435,91.7251Zm0-9.9356a4.7178,4.7178,0,1,0,4.7178,4.7178A4.7229,4.7229,0,0,0,105.7435,81.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.3255,91.3032a5.5469,5.5469,0,1,1,5.5479-5.5469A5.5531,5.5531,0,0,1,107.3255,91.3032Zm0-10.8437a5.2969,5.2969,0,1,0,5.2979,5.2968A5.3026,5.3026,0,0,0,107.3255,80.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.5716,70.17a5.0777,5.0777,0,1,1,5.0772-5.0776A5.0838,5.0838,0,0,1,107.5716,70.17Zm0-9.9053a4.8277,4.8277,0,1,0,4.8272,4.8277A4.8334,4.8334,0,0,0,107.5716,60.2646Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7552,43.3432a4.1205,4.1205,0,0,1-1.835-.4311h0a4.1422,4.1422,0,1,1,1.835.4311Zm-1.6123-.8793a3.64,3.64,0,1,0-1.6416-4.879,3.643,3.643,0,0,0,1.6416,4.879Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 108.3499,
    cy: 18.6839,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 106.7619,
    cy: 64.0923,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.4415,
    cy: 39.2039,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 106.7619,
    cy: 86.5072,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 11.889,
    cy: 9.0509,
    r: 2.3082
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.5454,13.5884a5.0931,5.0931,0,1,1,5.0928-5.0933A5.0985,5.0985,0,0,1,11.5454,13.5884Zm0-9.9361a4.8431,4.8431,0,1,0,4.8428,4.8428A4.8485,4.8485,0,0,0,11.5454,3.6523Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M56.1343,36.9311a5.6148,5.6148,0,1,1,5.6142-5.6147A5.6207,5.6207,0,0,1,56.1343,36.9311Zm0-10.98a5.3648,5.3648,0,1,0,5.3642,5.3648A5.3707,5.3707,0,0,0,56.1343,25.9516Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M54.9624,34.9082A5.2178,5.2178,0,1,1,60.18,29.69,5.2238,5.2238,0,0,1,54.9624,34.9082Zm0-9.9356A4.7178,4.7178,0,1,0,59.68,29.69,4.723,4.723,0,0,0,54.9624,24.9726Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M65.3979,24.96a4.5061,4.5061,0,1,1,4.5069-4.5063A4.5112,4.5112,0,0,1,65.3979,24.96Zm0-8.5122a4.0061,4.0061,0,1,0,4.0069,4.0059A4.01,4.01,0,0,0,65.3979,16.4477Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.8315,79.7988a5.2676,5.2676,0,1,1,5.2676-5.2676A5.2735,5.2735,0,0,1,12.8315,79.7988Zm0-10.0351a4.7676,4.7676,0,1,0,4.7676,4.7675A4.7728,4.7728,0,0,0,12.8315,69.7637Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.0581,24.8535a4.5061,4.5061,0,1,1,4.5059-4.5063A4.5113,4.5113,0,0,1,44.0581,24.8535Zm0-8.5122a4.0061,4.0061,0,1,0,4.0059,4.0059A4.01,4.01,0,0,0,44.0581,16.3413Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.8218,33.6675a4.5061,4.5061,0,1,1,4.5068-4.5059A4.5112,4.5112,0,0,1,10.8218,33.6675Zm0-8.5122a4.0061,4.0061,0,1,0,4.0068,4.0063A4.0106,4.0106,0,0,0,10.8218,25.1553Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.353,79.0376A4.5064,4.5064,0,1,1,59.86,74.5312,4.5113,4.5113,0,0,1,55.353,79.0376Zm0-8.5127A4.0064,4.0064,0,1,0,59.36,74.5312,4.0106,4.0106,0,0,0,55.353,70.5249Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.5083,47.3315a6.2854,6.2854,0,1,1,6.2852-6.2851A6.2928,6.2928,0,0,1,21.5083,47.3315Zm0-12.0708a5.7854,5.7854,0,1,0,5.7852,5.7857A5.7923,5.7923,0,0,0,21.5083,35.2607Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M74.7075,100.5156a4.7988,4.7988,0,1,1,4.7988-4.7988A4.804,4.804,0,0,1,74.7075,100.5156Zm0-9.0976a4.2988,4.2988,0,1,0,4.2988,4.2988A4.3037,4.3037,0,0,0,74.7075,91.418Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.7622,111.9756a5.2178,5.2178,0,1,1,5.2178-5.2178A5.2239,5.2239,0,0,1,107.7622,111.9756Zm0-9.9356a4.7178,4.7178,0,1,0,4.7178,4.7178A4.7229,4.7229,0,0,0,107.7622,102.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M74.1323,79.167a5.0928,5.0928,0,1,1,5.0938-5.0928A5.0983,5.0983,0,0,1,74.1323,79.167Zm0-9.9356a4.8428,4.8428,0,1,0,4.8438,4.8428A4.8485,4.8485,0,0,0,74.1323,69.2314Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.5532,79.1968a4.86,4.86,0,1,1,4.8594-4.8594A4.8654,4.8654,0,0,1,75.5532,79.1968Zm0-9.2193a4.36,4.36,0,1,0,4.3594,4.36A4.3652,4.3652,0,0,0,75.5532,69.9775Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.1968,90.5229a4.0261,4.0261,0,1,1,4.0263-4.0263A4.0311,4.0311,0,0,1,23.1968,90.5229Zm0-7.8022a3.7761,3.7761,0,1,0,3.7763,3.7759A3.7805,3.7805,0,0,0,23.1968,82.7207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M96.4614,100.3638a4.0264,4.0264,0,1,1,4.0264-4.0264A4.0312,4.0312,0,0,1,96.4614,100.3638Zm0-7.8028a3.7764,3.7764,0,1,0,3.7764,3.7764A3.7807,3.7807,0,0,0,96.4614,92.561Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.1353,89.521A4.1512,4.1512,0,1,1,28.2866,85.37,4.156,4.156,0,0,1,24.1353,89.521Zm0-7.8023A3.6512,3.6512,0,1,0,27.7866,85.37,3.6555,3.6555,0,0,0,24.1353,81.7187Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.7437,91.7251a5.2178,5.2178,0,1,1,5.2177-5.2178A5.2238,5.2238,0,0,1,105.7437,91.7251Zm0-9.9356a4.7178,4.7178,0,1,0,4.7177,4.7178A4.7229,4.7229,0,0,0,105.7437,81.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.3257,91.3032a5.5469,5.5469,0,1,1,5.5469-5.5469A5.5531,5.5531,0,0,1,107.3257,91.3032Zm0-10.8437a5.2969,5.2969,0,1,0,5.2969,5.2968A5.3026,5.3026,0,0,0,107.3257,80.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 55.3532,
    cy: 8.4042,
    r: 2.3082
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.9839,14.1426a5.0916,5.0916,0,1,1,5.0918-5.0918A5.0976,5.0976,0,0,1,55.9839,14.1426Zm0-9.9331a4.8416,4.8416,0,1,0,4.8418,4.8413A4.847,4.847,0,0,0,55.9839,4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M76.0786,57.834A5.0916,5.0916,0,1,1,81.17,52.7427,5.0975,5.0975,0,0,1,76.0786,57.834Zm0-9.9331A4.8416,4.8416,0,1,0,80.92,52.7427,4.8471,4.8471,0,0,0,76.0786,47.9009Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M98.6938,56.4175a4.5689,4.5689,0,1,1,4.5684-4.5689A4.5744,4.5744,0,0,1,98.6938,56.4175Zm0-8.8877a4.3189,4.3189,0,1,0,4.3184,4.3188A4.3239,4.3239,0,0,0,98.6938,47.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M100.6655,56.522a5.2027,5.2027,0,1,1,5.2022-5.2027A5.2088,5.2088,0,0,1,100.6655,56.522Zm0-9.9053a4.7027,4.7027,0,1,0,4.7022,4.7026A4.7078,4.7078,0,0,0,100.6655,46.6167Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.5708,70.2949a5.2027,5.2027,0,1,1,5.2031-5.2026A5.2085,5.2085,0,0,1,107.5708,70.2949Zm0-9.9053a4.7027,4.7027,0,1,0,4.7031,4.7027A4.7075,4.7075,0,0,0,107.5708,60.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M64.0776,47.209A5.2027,5.2027,0,1,1,69.28,42.0063,5.2088,5.2088,0,0,1,64.0776,47.209Zm0-9.9053A4.7027,4.7027,0,1,0,68.78,42.0063,4.7078,4.7078,0,0,0,64.0776,37.3037Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M96.4614,12.7573A4.7779,4.7779,0,1,1,101.24,7.98,4.7833,4.7833,0,0,1,96.4614,12.7573Zm0-9.0557A4.2779,4.2779,0,1,0,100.74,7.98,4.2825,4.2825,0,0,0,96.4614,3.7016Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M33.19,58.6308a5.6755,5.6755,0,1,1,5.6758-5.6757A5.6821,5.6821,0,0,1,33.19,58.6308Zm0-11.101a5.4255,5.4255,0,1,0,5.4258,5.4253A5.4313,5.4313,0,0,0,33.19,47.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M86.6343,25.3208a6.0081,6.0081,0,1,1,6.0088-6.0078A6.0149,6.0149,0,0,1,86.6343,25.3208Zm0-11.7661a5.7581,5.7581,0,1,0,5.7588,5.7583A5.7645,5.7645,0,0,0,86.6343,13.5547Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M56.1938,103.418a5.7986,5.7986,0,1,1,5.7979-5.7989A5.8057,5.8057,0,0,1,56.1938,103.418Zm0-11.3472a5.5486,5.5486,0,1,0,5.5479,5.5483A5.5548,5.5548,0,0,0,56.1938,92.0708Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.5337,89.7768a4.8318,4.8318,0,1,1,4.832-4.8315A4.8374,4.8374,0,0,1,85.5337,89.7768Zm0-9.4135a4.5818,4.5818,0,1,0,4.582,4.582A4.5873,4.5873,0,0,0,85.5337,80.3633Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.5454,57.5742a4.8318,4.8318,0,1,1,4.832-4.8315A4.8375,4.8375,0,0,1,11.5454,57.5742Zm0-9.4136a4.5818,4.5818,0,1,0,4.582,4.5821A4.5874,4.5874,0,0,0,11.5454,48.1606Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.896,100.814a4.2281,4.2281,0,1,1,4.2285-4.2281A4.2324,4.2324,0,0,1,32.896,100.814Zm0-8.2061a3.9781,3.9781,0,1,0,3.9785,3.978A3.9822,3.9822,0,0,0,32.896,92.6079Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.0581,46.4834a4.2281,4.2281,0,1,1,4.2285-4.228A4.2324,4.2324,0,0,1,44.0581,46.4834Zm0-8.2061a3.9781,3.9781,0,1,0,3.9785,3.9781A3.9823,3.9823,0,0,0,44.0581,38.2773Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M76.0786,37.0884A4.2281,4.2281,0,1,1,80.3071,32.86,4.2325,4.2325,0,0,1,76.0786,37.0884Zm0-8.2061a3.9781,3.9781,0,1,0,3.9785,3.978A3.9823,3.9823,0,0,0,76.0786,28.8823Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.8091,98.8061a4.228,4.228,0,1,1,4.2275-4.228A4.2324,4.2324,0,0,1,75.8091,98.8061Zm0-8.206a3.978,3.978,0,1,0,3.9775,3.978A3.9823,3.9823,0,0,0,75.8091,90.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.8765,67.8535a4.2281,4.2281,0,1,1,4.2275-4.228A4.2325,4.2325,0,0,1,85.8765,67.8535Zm0-8.2061a3.9781,3.9781,0,1,0,3.9775,3.9781A3.9823,3.9823,0,0,0,85.8765,59.6474Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 33.7045,
    cy: 7.8338,
    r: 1.8078
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34.3276,11.6372a4.1283,4.1283,0,0,1-1.8379-.4341h0a4.1128,4.1128,0,1,1,1.8379.4341Zm.01-7.7813a3.6392,3.6392,0,0,0-1.625,6.899h0a3.6393,3.6393,0,1,0,1.625-6.899Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M64.9907,67.7646a4.12,4.12,0,0,1-1.834-.4311h0a4.1422,4.1422,0,1,1,1.834.4311Zm.01-7.7807a3.64,3.64,0,0,0-1.6211,6.9013h0a3.64,3.64,0,1,0,1.6211-6.9013Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7573,43.3457a4.1264,4.1264,0,0,1-1.8369-.4336h0a4.115,4.115,0,1,1,1.8369.4336Zm-1.6142-.8818a3.64,3.64,0,1,0-1.6416-4.879,3.6238,3.6238,0,0,0,1.6416,4.879Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M97.228,33.8325a4.1311,4.1311,0,0,1-1.8379-.4341h0a4.1128,4.1128,0,1,1,1.8379.4341ZM95.6128,32.95a3.64,3.64,0,1,0-1.6416-4.8784A3.6451,3.6451,0,0,0,95.6128,32.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.7007,78.6733a4.1308,4.1308,0,0,1-1.8379-.4341h0a4.1132,4.1132,0,1,1,1.8379.4341Zm-1.6153-.8823a3.64,3.64,0,1,0-1.6416-4.8784,3.6081,3.6081,0,0,0,1.6416,4.8784Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.8433,23.12a5.2178,5.2178,0,1,1,4.6816-2.897A5.1854,5.1854,0,0,1,24.8433,23.12Zm.0127-9.938a4.7232,4.7232,0,1,0,2.0937.4951A4.727,4.727,0,0,0,24.856,13.1816Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.0532,89.4365a5.23,5.23,0,1,1,1.669-.2749A5.2,5.2,0,0,1,44.0532,89.4365Zm.0088-9.9409A4.719,4.719,0,0,0,41.96,88.4414h0a4.7176,4.7176,0,1,0,2.1016-8.9458Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43.96,68.1338a4.5166,4.5166,0,1,1,1.4415-.2373A4.49,4.49,0,0,1,43.96,68.1338Zm.0118-8.5137a4.0051,4.0051,0,1,0,1.7744.4175A4.0121,4.0121,0,0,0,43.9722,59.62Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 97.0033,
    cy: 8.4953,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 68.0472,
    cy: 107.2739,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 86.3436,
    cy: 20.1857,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.7622,5.2231A5.224,5.224,0,0,1,102.5444.0049a5.2178,5.2178,0,1,1,10.4356,0A5.2239,5.2239,0,0,1,107.7622,5.2231Zm0-9.936A4.7229,4.7229,0,0,0,103.0444.0049a4.7233,4.7233,0,0,0,4.7178,4.7182A4.7233,4.7233,0,0,0,112.48.0049,4.7229,4.7229,0,0,0,107.7622-4.7129Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: -0.5907,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0093,5.2231A5.2239,5.2239,0,0,1-4.2085.0049,5.2238,5.2238,0,0,1,1.0093-5.2129,5.2238,5.2238,0,0,1,6.227.0049,5.2239,5.2239,0,0,1,1.0093,5.2231Zm0-9.936A4.7229,4.7229,0,0,0-3.7085.0049,4.7233,4.7233,0,0,0,1.0093,4.7231,4.7233,4.7233,0,0,0,5.727.0049,4.7229,4.7229,0,0,0,1.0093-4.7129Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: -0.5907,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0093,111.9756a5.2178,5.2178,0,0,1,0-10.4356,5.2178,5.2178,0,0,1,0,10.4356Zm0-9.9356a4.7178,4.7178,0,0,0,0,9.4356,4.7178,4.7178,0,0,0,0-9.4356Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 66.0624,
    cy: 20.4537,
    r: 1.9848
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 43.9649,
    cy: 20.0902,
    r: 1.7241
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 34.7014,
    cy: 31.3947,
    r: 2.8992
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 11.5454,
    cy: 29.4763,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 25.033,
    cy: 17.6063,
    r: 2.4453
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 54.9324,
    cy: 31.3165,
    r: 2.1549
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 75.7075,
    cy: 32.8601,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.7583,109.9858a4.228,4.228,0,1,1,4.2275-4.228A4.2327,4.2327,0,0,1,22.7583,109.9858Zm0-8.206a3.978,3.978,0,1,0,3.9775,3.978A3.983,3.983,0,0,0,22.7583,101.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.3865,
    cy: 105.7579,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.7583,3.2329A4.2327,4.2327,0,0,1,18.53-.9951a4.2326,4.2326,0,0,1,4.2285-4.2276A4.2323,4.2323,0,0,1,26.9858-.9951,4.2324,4.2324,0,0,1,22.7583,3.2329Zm0-8.2056A3.9827,3.9827,0,0,0,18.78-.9951a3.9831,3.9831,0,0,0,3.9785,3.978,3.9822,3.9822,0,0,0,3.9775-3.978A3.9818,3.9818,0,0,0,22.7583-4.9727Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.3865,
    cy: -0.9949,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 96.8816,
    cy: 29.8601,
    r: 1.8753
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 86.6347,
    cy: 42.1996,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 108.3499,
    cy: 18.6839,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 65.1199,
    cy: 42.1996,
    r: 2.418
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.0583,
    cy: 42.2554,
    r: 2.8269
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.7578,
    cy: 42.0061,
    r: 1.8159
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 12.1337,
    cy: 52.7141,
    r: 2.0095
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 33.7052,
    cy: 53.5635,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 106.7619,
    cy: 64.0923,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 55.2704,
    cy: 52.5543,
    r: 2.3023
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 75.7075,
    cy: 51.9553,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 98.2319,
    cy: 51.3973,
    r: 1.3452
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.8764,
    cy: 63.6255,
    r: 2.4114
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 64.7319,
    cy: 64.1524,
    r: 2.2005
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.0046,
    cy: 62.1524,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.5259,4.85a4.843,4.843,0,0,1-4.584-3.3,4.8091,4.8091,0,0,1,.2529-3.7A4.8527,4.8527,0,0,1,87.689-4.3345,4.8508,4.8508,0,0,1,89.8726,2.16,4.8516,4.8516,0,0,1,85.5259,4.85ZM83.602,3.8965a4.3511,4.3511,0,0,0,5.8233-1.959,4.35,4.35,0,0,0-1.959-5.8237,4.35,4.35,0,0,0-5.8242,1.9589A4.318,4.318,0,0,0,81.4155,1.39,4.316,4.316,0,0,0,83.602,3.8965Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.5338,
    cy: -1.468,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.53,111.605a4.8276,4.8276,0,0,1-2.15-.5078h0a4.814,4.814,0,1,1,2.15.5078Zm.0117-9.1914a4.3439,4.3439,0,0,0-1.9395,8.2353h0a4.3444,4.3444,0,1,0,1.9395-8.2353Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.5338,
    cy: 105.2848,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.117,
    cy: 63.7454,
    r: 2.0314
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 11.9812,
    cy: 74.8419,
    r: 2.1619
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 33.1899,
    cy: 74.8419,
    r: 1.9965
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 55.7324,
    cy: 74.0741,
    r: 1.7475
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 75.1294,
    cy: 74.5313,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.4415,
    cy: 39.2039,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 96.6436,
    cy: 74.8419,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 106.7619,
    cy: 86.5072,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1.0093,91.7251a5.2239,5.2239,0,0,1-5.2178-5.2178A5.224,5.224,0,0,1-1.0093,81.29a5.2239,5.2239,0,0,1,5.2178,5.2178A5.2238,5.2238,0,0,1-1.0093,91.7251Zm0-9.9356a4.723,4.723,0,0,0-4.7178,4.7178,4.723,4.723,0,0,0,4.7178,4.7178,4.7229,4.7229,0,0,0,4.7178-4.7178A4.7229,4.7229,0,0,0-1.0093,81.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.5728,91.3032a5.5469,5.5469,0,1,1,0-11.0937,5.5469,5.5469,0,1,1,0,11.0937Zm0-10.8437a5.2969,5.2969,0,1,0,0,10.5937,5.2969,5.2969,0,1,0,0-10.5937Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.8188,70.17a5.0777,5.0777,0,1,1,0-10.1553,5.0777,5.0777,0,0,1,0,10.1553Zm0-9.9053a4.8277,4.8277,0,1,0,0,9.6553,4.8277,4.8277,0,0,0,0-9.6553Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.0024,43.3432a4.12,4.12,0,0,1-1.8349-.4311h0a4.1461,4.1461,0,0,1-1.8662-5.55A4.1436,4.1436,0,0,1,1.85,35.4961a4.1137,4.1137,0,0,1,2.083,2.3877,4.1126,4.1126,0,0,1-.2168,3.1616A4.1438,4.1438,0,0,1,.0024,43.3432ZM-1.61,42.4639A3.643,3.643,0,0,0,3.269,40.8227a3.6168,3.6168,0,0,0,.19-2.7793,3.6179,3.6179,0,0,0-1.8321-2.0991,3.6423,3.6423,0,0,0-4.8789,1.6406A3.6459,3.6459,0,0,0-1.61,42.4639Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.5971,
    cy: 18.6839,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.0091,
    cy: 64.0923,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6888,
    cy: 39.2039,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.0091,
    cy: 86.5072,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 86.3631,
    cy: 85.5119,
    r: 1.523
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 74.9799,
    cy: 11.6308,
    r: 1.523
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.9321,111.7842a4.0264,4.0264,0,1,1,4.0264-4.0264A4.0312,4.0312,0,0,1,67.9321,111.7842Zm0-7.8028a3.7764,3.7764,0,1,0,3.7764,3.7764A3.7807,3.7807,0,0,0,67.9321,103.9814Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 64.7319,
    cy: 85.4129,
    r: 1.8349
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 43.9649,
    cy: 85.4129,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 68.0472,
    cy: 0.3874,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.9321,4.8974A4.031,4.031,0,0,1,63.9058.8716a4.0264,4.0264,0,1,1,8.0527,0A4.031,4.031,0,0,1,67.9321,4.8974Zm0-7.8022A3.7806,3.7806,0,0,0,64.1558.8716a3.7764,3.7764,0,0,0,7.5527,0A3.7806,3.7806,0,0,0,67.9321-2.9048Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.6773,
    cy: 0.0051,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 33.1899,
    cy: 96.2562,
    r: 1.5727
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 23.2637,
    cy: 86.1317,
    r: 1.9158
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 10.8221,
    cy: 96.6907,
    r: 2.0096
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 54.9334,
    cy: 96.3375,
    r: 2.5465
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 75.0787,
    cy: 95.586,
    r: 1.5598
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 96.6436,
    cy: 96.3375,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.27,49.74a.25.25,0,0,1-.25-.25V44.6177a.25.25,0,0,1,.5,0V49.49A.25.25,0,0,1,55.27,49.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M57.0874,50.1343a.25.25,0,0,1-.2119-.3833l1.33-2.1084a.25.25,0,0,1,.4238.2666l-1.33,2.1084A.25.25,0,0,1,57.0874,50.1343Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M58.2124,51.3633a.1249.1249,0,0,1-.0371-.2442l5.6191-1.7719a.1283.1283,0,0,1,.1563.0815.1247.1247,0,0,1-.082.1567L58.25,51.3574A.1181.1181,0,0,1,58.2124,51.3633Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M62.3921,53.9145a.2739.2739,0,0,1-.0332-.0019l-4.0567-.5391a.2507.2507,0,0,1-.2148-.2807.2434.2434,0,0,1,.2813-.2154l4.0566.5391a.25.25,0,0,1-.0332.498Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M57.5728,60.7515a.1248.1248,0,0,1-.12-.0918L56.0142,55.415a.1246.1246,0,1,1,.24-.0664l1.4385,5.2446a.1249.1249,0,0,1-.0869.1539A.1312.1312,0,0,1,57.5728,60.7515Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M58.9956,56.8628a.248.248,0,0,1-.1865-.084l-1.4229-1.6a.25.25,0,1,1,.3731-.332l1.4228,1.6a.25.25,0,0,1-.1865.416Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.9868,59.0884a.2713.2713,0,0,1-.0439-.0039.25.25,0,0,1-.2022-.29l.585-3.2925a.2471.2471,0,0,1,.29-.2021.25.25,0,0,1,.2022.29l-.585,3.2925A.25.25,0,0,1,53.9868,59.0884Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.5249,56.1225a.1231.1231,0,0,1-.0908-.04.125.125,0,0,1,.0049-.1768l1.4433-1.354a.1254.1254,0,0,1,.1719.1826l-1.4434,1.3541A.1275.1275,0,0,1,51.5249,56.1225Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M47.4321,53.5625a.125.125,0,0,1-.0166-.249l4.6709-.6314a.1252.1252,0,0,1,.0332.2481l-4.6709.6313Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M52.2466,50.9956a.2489.2489,0,0,1-.1309-.0371l-2.0351-1.2554a.25.25,0,1,1,.2617-.4258l2.0351,1.2554a.25.25,0,0,1-.1308.4629Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.5767,49.8862a.1241.1241,0,0,1-.1133-.0727l-1.56-3.4029a.1248.1248,0,1,1,.2266-.1045l1.56,3.4029a.1242.1242,0,0,1-.0615.166A.1208.1208,0,0,1,53.5767,49.8862Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.5513,31.3784l-.0264-.0015-7.1475-.7627a.25.25,0,1,1,.0528-.497l7.1474.7627a.25.25,0,0,1-.0263.4985Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.52,28.9648a.25.25,0,0,1-.14-.0425l-3.3985-2.2875a.25.25,0,0,1,.2793-.4151L31.66,28.5073a.25.25,0,0,1-.14.4575Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M33.5835,27.9267a.1254.1254,0,0,1-.1231-.104L32.227,20.6172a.125.125,0,0,1,.1016-.1441.12.12,0,0,1,.1445.1021l1.2334,7.2055a.1248.1248,0,0,1-.1015.1441Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.1645,28.2729a.2475.2475,0,0,1-.0673-.0092.2506.2506,0,0,1-.1739-.3081l1.3477-4.82a.25.25,0,0,1,.4824.1348l-1.3476,4.82A.2511.2511,0,0,1,36.1645,28.2729Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38.2085,29.7412a.125.125,0,0,1-.0381-.2441L42.94,27.96a.1271.1271,0,0,1,.1573.0805.1249.1249,0,0,1-.0811.1577l-4.77,1.5376A.1293.1293,0,0,1,38.2085,29.7412Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M45.689,34.3955a.2435.2435,0,0,1-.0528-.0059l-7.3984-1.6079a.2492.2492,0,0,1-.1914-.2973.2521.2521,0,0,1,.2969-.191l7.3984,1.608a.25.25,0,0,1-.0527.4941Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M39.2661,37.5693a.2475.2475,0,0,1-.2109-.1162l-1.917-3.0283a.25.25,0,1,1,.4219-.2676l1.9169,3.0283a.25.25,0,0,1-.0771.3452A.2537.2537,0,0,1,39.2661,37.5693Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.6714,40.8545a.1248.1248,0,0,1-.1231-.105l-.8593-5.36a.1245.1245,0,0,1,.1035-.1435.1284.1284,0,0,1,.1426.1035l.8593,5.36a.1245.1245,0,0,1-.1035.1435Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.561,40.9848a.25.25,0,0,1-.2334-.3383L32.4907,34.92a.252.252,0,0,1,.3213-.1455.2494.2494,0,0,1,.1455.3223l-2.1631,5.7265A.249.249,0,0,1,30.561,40.9848Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.7915,34.8266a.125.125,0,0,1-.0586-.2353l2.0879-1.1128a.1249.1249,0,0,1,.1172.2207L28.85,34.812A.1268.1268,0,0,1,28.7915,34.8266Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M88.5474,39.9136a.1248.1248,0,0,1-.0948-.2066l3.1153-3.6138a.125.125,0,1,1,.1894.1631L88.6421,39.87A.1239.1239,0,0,1,88.5474,39.9136Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.1323,41.4639a.25.25,0,0,1-.0293-.4986l2.8614-.3354a.2589.2589,0,0,1,.2773.2192.25.25,0,0,1-.2188.2778l-2.8613.3355Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M94.8989,43.9438l-.0166-.0009-5.12-.6841a.1256.1256,0,0,1-.1074-.1406.1238.1238,0,0,1,.1406-.1075l5.12.6841a.125.125,0,0,1-.0166.249Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.6489,46.2617a.1261.1261,0,0,1-.084-.0322L88.66,44.5185a.1251.1251,0,0,1,.1679-.1855l1.9053,1.7109a.1252.1252,0,0,1-.084.2178Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M88.3589,51.2041a.25.25,0,0,1-.2451-.1992l-1.1407-5.5166a.2508.2508,0,0,1,.1944-.2954.2458.2458,0,0,1,.2959.1938l1.1406,5.5166a.2508.2508,0,0,1-.1943.2954A.2312.2312,0,0,1,88.3589,51.2041Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M81.6675,46.88a.25.25,0,0,1-.169-.4346L84.17,44.0039a.25.25,0,0,1,.3379.3691l-2.6719,2.4414A.2483.2483,0,0,1,81.6675,46.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M77.0854,44.2988a.25.25,0,0,1-.0419-.4966L83.644,42.666a.25.25,0,0,1,.084.4932l-6.6006,1.1362A.247.247,0,0,1,77.0854,44.2988Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M83.2769,41.2187l-.0254-.0024L78.95,40.3315a.1245.1245,0,0,1-.0967-.1479.1224.1224,0,0,1,.1475-.0972l4.3017.8848a.1251.1251,0,0,1-.0253.2475Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M84.7632,39.89a.1239.1239,0,0,1-.0977-.0469L81.8511,36.314a.1251.1251,0,0,1,.1953-.1563l2.8144,3.5293a.1249.1249,0,0,1-.0976.2031Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M86.6343,38.6269a.25.25,0,0,1-.25-.25V32.2222a.25.25,0,0,1,.5,0v6.1547A.25.25,0,0,1,86.6343,38.6269Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M84.9976,47.084a.1257.1257,0,0,1-.1182-.167l.5976-1.6778a.1254.1254,0,0,1,.2364.084l-.5977,1.6778A.1253.1253,0,0,1,84.9976,47.084Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.4214,62.3862a.1216.1216,0,0,1-.0645-.018l-4.083-2.4693a.1249.1249,0,1,1,.1289-.2139l4.083,2.4693a.1249.1249,0,0,1,.043.1714A.1268.1268,0,0,1,19.4214,62.3862Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.562,60.7109a.2505.2505,0,0,1-.24-.18l-.8067-2.7651a.25.25,0,1,1,.48-.14l.8066,2.7651a.2513.2513,0,0,1-.17.31A.27.27,0,0,1,20.562,60.7109Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.5151,60.6142a.1248.1248,0,0,1-.125-.1206l-.1787-5.1621a.1259.1259,0,0,1,.1211-.1294.1217.1217,0,0,1,.1289.1206l.1787,5.1621a.1256.1256,0,0,1-.1211.1294Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.96,61.5454a.2534.2534,0,0,1-.1337-.0386.25.25,0,0,1-.0772-.3452l1.37-2.1641a.25.25,0,1,1,.4219.2676l-1.37,2.1641A.2477.2477,0,0,1,23.96,61.5454Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.2124,62.7558a.1251.1251,0,0,1-.0449-.2417l5.249-2.0439a.125.125,0,0,1,.09.2334l-5.249,2.0439A.1318.1318,0,0,1,25.2124,62.7558Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.313,68.1553a.2484.2484,0,0,1-.1543-.0533l-2.8525-2.2285a.25.25,0,1,1,.3085-.3935l2.8526,2.2285a.25.25,0,0,1-.1543.4468Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.5308,73.103a.2506.2506,0,0,1-.2364-.167l-2.22-6.3193a.2505.2505,0,0,1,.4727-.166l2.22,6.3193a.25.25,0,0,1-.2363.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.43,71.7539h-.0049a.1255.1255,0,0,1-.12-.1294l.1552-4.3887a.1254.1254,0,0,1,.125-.1206H21.59a.1256.1256,0,0,1,.12.1294l-.1552,4.3887A.1254.1254,0,0,1,21.43,71.7539Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.0171,69.6094a.25.25,0,0,1-.1865-.417L19.8423,65.83a.25.25,0,0,1,.373.334l-3.0117,3.3628A.2527.2527,0,0,1,17.0171,69.6094Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.2788,65.5327a.1249.1249,0,0,1-.0205-.248l6.0684-1.0254a.1247.1247,0,1,1,.041.2461l-6.0684,1.0253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.0825,64.8164a.2225.2225,0,0,1-.043-.0039l-1.7539-.3091a.2491.2491,0,0,1-.2031-.29.2461.2461,0,0,1,.2891-.2027l1.7539.3091a.25.25,0,0,1-.043.4961Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M98.96,72.7754a.25.25,0,0,1-.14-.4575l2.9434-1.9756a.25.25,0,1,1,.2793.415L99.1,72.7329A.2506.2506,0,0,1,98.96,72.7754Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M97.4868,71.7876a.2671.2671,0,0,1-.0586-.0069.25.25,0,0,1-.1845-.3017l1.4736-6.12a.2547.2547,0,0,1,.3017-.1846.2506.2506,0,0,1,.1846.3018l-1.4736,6.12A.25.25,0,0,1,97.4868,71.7876Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M95.3481,71.6626a.1258.1258,0,0,1-.122-.0972l-.7774-3.3994a.1256.1256,0,0,1,.0938-.15.1242.1242,0,0,1,.15.0942l.7773,3.4a.1257.1257,0,0,1-.0937.15A.1521.1521,0,0,1,95.3481,71.6626Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M94.0073,72.65a.1257.1257,0,0,1-.0888-.0371l-3.3633-3.419a.125.125,0,0,1,.1777-.1758l3.3633,3.419a.1251.1251,0,0,1-.0889.2129Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.5229,74.5586a.2419.2419,0,0,1-.0322-.002l-3.2822-.42a.25.25,0,0,1-.2158-.28.2451.2451,0,0,1,.28-.2163l3.2823.42a.25.25,0,0,1-.0323.4981Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M88.2876,77.5181a.125.125,0,0,1-.0264-.2471l5.4112-1.1821a.1273.1273,0,0,1,.1484.0952.1254.1254,0,0,1-.0957.1489L88.314,77.5151A.1188.1188,0,0,1,88.2876,77.5181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.5513,79.5459a.2473.2473,0,0,1-.1465-.0474.2506.2506,0,0,1-.0567-.3491l1.2862-1.7808a.25.25,0,0,1,.4062.293l-1.2861,1.7808A.2526.2526,0,0,1,93.5513,79.5459Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M95.8862,83.7031l-.0088-.0005a.1247.1247,0,0,1-.1162-.1328l.3789-5.5742a.13.13,0,0,1,.1338-.1162.1246.1246,0,0,1,.1162.1328l-.3789,5.5742A.1257.1257,0,0,1,95.8862,83.7031Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M99.4419,79.72a.25.25,0,0,1-.2012-.1016L98.022,77.9692a.25.25,0,0,1,.0527-.35.2527.2527,0,0,1,.35.0527l1.2188,1.6495a.25.25,0,0,1-.2012.3984Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M102.6187,77.7622a.1208.1208,0,0,1-.0547-.0127l-2.9327-1.4263a.1249.1249,0,1,1,.1094-.2246l2.9326,1.4263a.1249.1249,0,0,1-.0546.2373Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M100.1138,74.4624a.1248.1248,0,0,1-.0176-.2485l6.1885-.8985a.1211.1211,0,0,1,.1416.1055.1255.1255,0,0,1-.1065.1416l-6.1885.8984Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M64.0308,82.6465a.25.25,0,0,1-.2442-.1973l-1.1338-5.2383a.25.25,0,1,1,.4883-.1054l1.1338,5.2382a.25.25,0,0,1-.1914.2969A.2433.2433,0,0,1,64.0308,82.6465Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M65.7368,82.7832a.2465.2465,0,0,1-.1074-.0244.2493.2493,0,0,1-.1182-.333l.83-1.7422a.252.252,0,0,1,.333-.1182.2493.2493,0,0,1,.1182.333l-.83,1.7422A.2506.2506,0,0,1,65.7368,82.7832Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M66.9321,84.1138a.1252.1252,0,0,1-.0537-.2383l3.5293-1.6612a.1254.1254,0,0,1,.1074.2266L66.9858,84.102A.1333.1333,0,0,1,66.9321,84.1138Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.2427,86.3442l-.0147-.0005-5.6572-.3379a.2509.2509,0,0,1-.2354-.2646.2416.2416,0,0,1,.2647-.2344l5.6572.3379a.25.25,0,0,1-.0146.4995Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.27,89.584a.2493.2493,0,0,1-.208-.1118l-1.1182-1.6885a.25.25,0,1,1,.4161-.2764l1.1181,1.6885a.25.25,0,0,1-.208.3882Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M63.4644,92.0708l-.0176-.0015a.1247.1247,0,0,1-.1065-.1411l.5664-4.0024a.1217.1217,0,0,1,.1416-.106.1248.1248,0,0,1,.1065.1411l-.5664,4.0025A.1251.1251,0,0,1,63.4644,92.0708Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M59.9155,87.8955a.25.25,0,0,1-.126-.4658l1.9512-1.1382a.25.25,0,0,1,.252.4316l-1.9512,1.1382A.2465.2465,0,0,1,59.9155,87.8955Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M61.8667,85.07l-.0088-.0005-5.8828-.4258a.1248.1248,0,0,1-.1162-.1333.1283.1283,0,0,1,.1338-.1157l5.8828.4258a.1249.1249,0,0,1-.0088.2495Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M62.5317,83.2832a.1248.1248,0,0,1-.0849-.0332L61.022,81.9355a.1251.1251,0,1,1,.17-.1836l1.4248,1.3145a.125.125,0,0,1-.085.2168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M50.9985,3.8174a.121.121,0,0,1-.0586-.0147L47.4272,1.9512a.1249.1249,0,0,1,.1172-.2207L51.0571,3.582a.1251.1251,0,0,1-.0586.2354Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M47.063,5.2451a.2481.2481,0,0,1-.2276-.1475L45.92,3.0625a.25.25,0,1,1,.4551-.2051l.915,2.0352a.25.25,0,0,1-.125.33A.2458.2458,0,0,1,47.063,5.2451Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43.0483,7.4263a.1457.1457,0,0,1-.0254-.0025.1245.1245,0,0,1-.0966-.1484L43.811,3.07a.1313.1313,0,0,1,.1475-.0967.1247.1247,0,0,1,.0967.1485L43.17,7.3271A.1247.1247,0,0,1,43.0483,7.4263Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.6128,4.6763a.1249.1249,0,0,1-.0986-.2017l1.6279-2.106a.123.123,0,0,1,.1748-.0224.1249.1249,0,0,1,.0225.1758l-1.628,2.1059A.1242.1242,0,0,1,40.6128,4.6763Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38.4106,2.46a.25.25,0,0,1-.1035-.4776L41.4478.5493a.25.25,0,0,1,.207.4551L38.5142,2.437A.25.25,0,0,1,38.4106,2.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.6773,
    cy: 106.7579,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M41.7085,105.5215a.1211.1211,0,0,1-.0547-.0127l-4.0889-1.99a.1249.1249,0,1,1,.1094-.2246l4.0889,1.99a.125.125,0,0,1-.0547.2373Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43.0278,104.4512a.2493.2493,0,0,1-.205-.1075l-1.6563-2.3818a.25.25,0,0,1,.41-.2852l1.6562,2.3819a.2493.2493,0,0,1-.0625.3476A.2466.2466,0,0,1,43.0278,104.4512Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.7319,103.8076l-.0273-.0015a.25.25,0,0,1-.2207-.2758l.6689-6.0957a.2419.2419,0,0,1,.2754-.2212.25.25,0,0,1,.2207.2758l-.6689,6.0957A.25.25,0,0,1,44.7319,103.8076Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M46.688,104.626a.1251.1251,0,0,1-.1026-.1963l2.4034-3.4683a.1237.1237,0,0,1,.1738-.0312.125.125,0,0,1,.0312.1738l-2.4033,3.4683A.1249.1249,0,0,1,46.688,104.626Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.6167,9.0088l-.0225-.002a.1247.1247,0,0,1-.1-.145l.8857-4.9062a.12.12,0,0,1,.1455-.1011A.1247.1247,0,0,1,76.6255,4L75.74,8.9057A.1249.1249,0,0,1,75.6167,9.0088Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M77.352,10.0381a.25.25,0,0,1-.1572-.4444l2.3125-1.8715a.25.25,0,1,1,.3145.3886L77.5093,9.9824A.247.247,0,0,1,77.352,10.0381Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M83.4409,11.7558H77.78a.125.125,0,0,1,0-.25h5.6611a.125.125,0,0,1,0,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M78.314,14.6182a.1244.1244,0,0,1-.0762-.0259l-1.39-1.0635a.125.125,0,1,1,.1524-.1982l1.39,1.0634a.1251.1251,0,0,1,.0235.1753A.128.128,0,0,1,78.314,14.6182Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M76.105,18.9341a.25.25,0,0,1-.2471-.2139L75.18,14.0537a.25.25,0,1,1,.4941-.0723l.6777,4.6665a.2493.2493,0,0,1-.2109.2837A.3059.3059,0,0,1,76.105,18.9341Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M72.2905,16.2163a.123.123,0,0,1-.0595-.0151.1253.1253,0,0,1-.05-.17l1.166-2.13a.1248.1248,0,1,1,.2187.12l-1.166,2.13A.1243.1243,0,0,1,72.2905,16.2163Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M68.0474,14.2114a.25.25,0,0,1-.0811-.4863l4.4785-1.5391a.25.25,0,0,1,.1621.4727l-4.4785,1.539A.2431.2431,0,0,1,68.0474,14.2114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M71.8335,10.8374A.1306.1306,0,0,1,71.8,10.833l-2.1787-.6045a.1251.1251,0,0,1,.0664-.2412l2.1787.6045a.1251.1251,0,0,1-.0332.2456Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.3374,9.5981a.25.25,0,0,1-.2207-.1328l-1.624-3.06a.25.25,0,0,1,.4414-.2344l1.624,3.06a.25.25,0,0,1-.1035.3379A.2445.2445,0,0,1,73.3374,9.5981Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M102.7017,22.8662a.25.25,0,0,1-.1377-.459l3.3681-2.2182a.25.25,0,1,1,.2754.4179l-3.3681,2.2183A.2508.2508,0,0,1,102.7017,22.8662Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M98.1938,19.563a.25.25,0,0,1-.0214-.499l7.44-.629a.2381.2381,0,0,1,.2705.2281.25.25,0,0,1-.2275.27l-7.44.6289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.7856,17.2046a.1207.1207,0,0,1-.0546-.0127l-1.8165-.8819a.1251.1251,0,0,1-.0576-.1669.1266.1266,0,0,1,.167-.0577l1.8164.8819a.125.125,0,0,1-.0547.2373Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7622,16.4477a.2486.2486,0,0,1-.2246-.1411l-1.5049-3.1128a.25.25,0,1,1,.4492-.2177l1.5049,3.1128a.2489.2489,0,0,1-.1162.3339A.2414.2414,0,0,1,106.7622,16.4477Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.5972,16.2544a.25.25,0,0,1-.25-.25V10.9805a.25.25,0,0,1,.5,0v5.0239A.25.25,0,0,1,1.5972,16.2544Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.2124,16.5107a.123.123,0,0,1-.0762-.0263.125.125,0,0,1-.0224-.1753l1.4736-1.8985a.125.125,0,0,1,.1973.1534L3.311,16.4624A.1243.1243,0,0,1,3.2124,16.5107Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.9,17.87a.1248.1248,0,0,1-.0322-.2456l6.4375-1.74a.1281.1281,0,0,1,.1533.0879.1252.1252,0,0,1-.0889.1533l-6.4375,1.74A.119.119,0,0,1,3.9,17.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8,20.5757a.2772.2772,0,0,1-.0527-.0054l-3.9815-.8555a.25.25,0,0,1-.1914-.2973.2558.2558,0,0,1,.2969-.1919l3.9814.8554A.25.25,0,0,1,8,20.5757Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.7661,25.4458a.2475.2475,0,0,1-.206-.1089L2.8384,21.3515a.25.25,0,1,1,.4121-.2822l2.7217,3.9854a.25.25,0,0,1-.2061.3911Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.396,23.749a.1253.1253,0,0,1-.1221-.1514l.5244-2.4331a.1249.1249,0,0,1,.2442.0528L.5181,23.65A.1251.1251,0,0,1,.396,23.749Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.8188,94.041a.25.25,0,0,1-.2392-.1768l-.71-2.3159a.25.25,0,1,1,.4785-.1465l.71,2.316a.2511.2511,0,0,1-.166.3125A.254.254,0,0,1,9.8188,94.041Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.5454,93.916l-.0215-.002a.1248.1248,0,0,1-.1015-.145l1.2861-7.2837a.1214.1214,0,0,1,.1445-.101.1249.1249,0,0,1,.1016.145L11.6685,93.813A.1251.1251,0,0,1,11.5454,93.916Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.8315,94.499a.1254.1254,0,0,1-.0878-.2143l2.4814-2.4283a.1253.1253,0,0,1,.1758.1787l-2.4815,2.4283A.1258.1258,0,0,1,12.8315,94.499Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.6528,96.5063a.25.25,0,0,1-.0341-.4975l6.2685-.8584a.2458.2458,0,0,1,.2822.2138.25.25,0,0,1-.2138.2813l-6.2686.8584A.2735.2735,0,0,1,13.6528,96.5063Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.7876,98.6562a.2448.2448,0,0,1-.0459-.0044l-3.07-.5771a.2505.2505,0,0,1-.2-.292.246.246,0,0,1,.292-.1992l3.07.5771a.25.25,0,0,1-.0459.4956Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.0728,103.3843a.1233.1233,0,0,1-.1084-.0635L11.8726,99.62a.1246.1246,0,1,1,.2168-.123l2.0918,3.7011a.1247.1247,0,0,1-.0469.1705A.1293.1293,0,0,1,14.0728,103.3843Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.8188,104.9282l-.0283-.0015a.25.25,0,0,1-.22-.2773l.57-4.9282a.2547.2547,0,0,1,.2764-.22.25.25,0,0,1,.22.2773l-.57,4.9282A.2493.2493,0,0,1,9.8188,104.9282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.8384,100.6348a.1249.1249,0,0,1-.0791-.2217l1.9746-1.626a.1249.1249,0,1,1,.1582.1934l-1.9746,1.6259A.1218.1218,0,0,1,6.8384,100.6348Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.3257,97.312a.25.25,0,0,1-.002-.5l5.6875-.05a.2534.2534,0,0,1,.252.248.25.25,0,0,1-.2481.252l-5.6875.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.2134,95.2a.2474.2474,0,0,1-.1338-.0391l-2.8164-1.79a.25.25,0,1,1,.2676-.4219l2.8164,1.79a.25.25,0,0,1-.1338.461Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.01,111.9756a5.2178,5.2178,0,0,1,0-10.4356,5.2178,5.2178,0,0,1,0,10.4356Zm0-9.9356a4.7178,4.7178,0,0,0,0,9.4356,4.7178,4.7178,0,0,0,0-9.4356Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1.0091,91.7251a5.2238,5.2238,0,0,1-5.2178-5.2178A5.2239,5.2239,0,0,1-1.0091,81.29a5.224,5.224,0,0,1,5.2178,5.2178A5.2239,5.2239,0,0,1-1.0091,91.7251Zm0-9.9356a4.7229,4.7229,0,0,0-4.7178,4.7178,4.7229,4.7229,0,0,0,4.7178,4.7178,4.7229,4.7229,0,0,0,4.7178-4.7178A4.7229,4.7229,0,0,0-1.0091,81.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.5729,91.3032a5.5469,5.5469,0,0,1,0-11.0937,5.5469,5.5469,0,1,1,0,11.0937Zm0-10.8437a5.2969,5.2969,0,0,0,0,10.5937,5.2969,5.2969,0,1,0,0-10.5937Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.818,70.2949a5.2027,5.2027,0,0,1,0-10.4053,5.2027,5.2027,0,1,1,0,10.4053Zm0-9.9053a4.7027,4.7027,0,0,0,0,9.4053,4.7027,4.7027,0,1,0,0-9.4053Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.0046,43.3457a4.1261,4.1261,0,0,1-1.8369-.4336h0a4.1462,4.1462,0,0,1-1.8663-5.55A4.1435,4.1435,0,0,1,1.85,35.4961a4.1171,4.1171,0,0,1,2.083,2.3877,4.1126,4.1126,0,0,1-.2168,3.1616,4.1079,4.1079,0,0,1-2.3877,2.082A4.1451,4.1451,0,0,1,.0046,43.3457ZM-1.61,42.4639a3.6238,3.6238,0,0,0,2.7793.19,3.6166,3.6166,0,0,0,2.1-1.8311,3.6127,3.6127,0,0,0,.1895-2.7793,3.6129,3.6129,0,0,0-1.8311-2.0991,3.6423,3.6423,0,0,0-4.8789,1.6406A3.6458,3.6458,0,0,0-1.61,42.4639Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.01,5.2231A5.2239,5.2239,0,0,1-4.2083.0049,5.2238,5.2238,0,0,1,1.01-5.2129,5.2238,5.2238,0,0,1,6.2272.0049,5.2239,5.2239,0,0,1,1.01,5.2231Zm0-9.936A4.7229,4.7229,0,0,0-3.7083.0049,4.7233,4.7233,0,0,0,1.01,4.7231,4.7233,4.7233,0,0,0,5.7272.0049,4.7229,4.7229,0,0,0,1.01-4.7129Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: -0.5907,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.5971,
    cy: 18.6839,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.0091,
    cy: 64.0923,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6888,
    cy: 39.2039,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.0091,
    cy: 86.5072,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.01,16.4477a.2487.2487,0,0,1-.2247-.1411L-1.72,13.1938a.249.249,0,0,1,.1162-.334.25.25,0,0,1,.333.1163L.2341,16.0889a.249.249,0,0,1-.1163.3339A.2407.2407,0,0,1,.01,16.4477Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.762,5.2228A5.2238,5.2238,0,0,1,102.5443.005a5.2178,5.2178,0,0,1,10.4355,0A5.2238,5.2238,0,0,1,107.762,5.2228Zm0-9.9355A4.7228,4.7228,0,0,0,103.0443.005a4.7229,4.7229,0,0,0,4.7177,4.7178A4.7229,4.7229,0,0,0,112.48.005,4.7229,4.7229,0,0,0,107.762-4.7127Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: -0.5907,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.7622,5.2228A5.2239,5.2239,0,0,1,102.5444.005a5.2178,5.2178,0,0,1,10.4356,0A5.2238,5.2238,0,0,1,107.7622,5.2228Zm0-9.9355A4.7229,4.7229,0,0,0,103.0444.005a4.7229,4.7229,0,0,0,4.7178,4.7178A4.7229,4.7229,0,0,0,112.48.005,4.7229,4.7229,0,0,0,107.7622-4.7127Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 68.0472,
    cy: 0.5211,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: -0.5907,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0093,5.2228A5.2238,5.2238,0,0,1-4.2085.005,5.2238,5.2238,0,0,1,1.0093-5.2127,5.2238,5.2238,0,0,1,6.227.005,5.2238,5.2238,0,0,1,1.0093,5.2228Zm0-9.9355A4.7229,4.7229,0,0,0-3.7085.005,4.7229,4.7229,0,0,0,1.0093,4.7228,4.7229,4.7229,0,0,0,5.727.005,4.7228,4.7228,0,0,0,1.0093-4.7127Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: -0.5907,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.7583,3.2331A4.2327,4.2327,0,0,1,18.53-.995a4.2327,4.2327,0,0,1,4.2285-4.228A4.2324,4.2324,0,0,1,26.9858-.995,4.2324,4.2324,0,0,1,22.7583,3.2331Zm0-8.2061A3.9831,3.9831,0,0,0,18.78-.995a3.9831,3.9831,0,0,0,3.9785,3.9781A3.9823,3.9823,0,0,0,26.7358-.995,3.9822,3.9822,0,0,0,22.7583-4.973Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.3865,
    cy: -0.9949,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.53,4.8522a4.8276,4.8276,0,0,1-2.15-.5078h0A4.8117,4.8117,0,0,1,80.9419,1.55a4.8091,4.8091,0,0,1,.2529-3.7A4.8524,4.8524,0,0,1,87.689-4.3343a4.811,4.811,0,0,1,2.4365,2.7949A4.8079,4.8079,0,0,1,89.8726,2.16a4.81,4.81,0,0,1-2.794,2.437A4.8436,4.8436,0,0,1,85.53,4.8522Zm.0117-9.1914a4.3514,4.3514,0,0,0-3.8994,2.4121A4.318,4.318,0,0,0,81.4155,1.39,4.3139,4.3139,0,0,0,83.602,3.8962h0a4.3107,4.3107,0,0,0,3.3165.227,4.3179,4.3179,0,0,0,2.5068-2.186A4.3177,4.3177,0,0,0,89.6519-1.38a4.3158,4.3158,0,0,0-2.1856-2.5059A4.314,4.314,0,0,0,85.5415-4.3392Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.5338,
    cy: -1.468,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.9321,5.0314A4.0264,4.0264,0,1,1,71.9585,1.005,4.0311,4.0311,0,0,1,67.9321,5.0314Zm0-7.8027A3.7764,3.7764,0,1,0,71.7085,1.005,3.7806,3.7806,0,0,0,67.9321-2.7713Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.6773,
    cy: 0.0051,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.01,5.2228A5.2238,5.2238,0,0,1-4.2083.005,5.2238,5.2238,0,0,1,1.01-5.2127,5.2238,5.2238,0,0,1,6.2272.005,5.2238,5.2238,0,0,1,1.01,5.2228Zm0-9.9355A4.7229,4.7229,0,0,0-3.7083.005,4.7229,4.7229,0,0,0,1.01,4.7228,4.7229,4.7229,0,0,0,5.7272.005,4.7228,4.7228,0,0,0,1.01-4.7127Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: -0.5907,
    r: 2.9027
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 23.0421,
    y: 55.7928,
    width: 129.7161,
    height: 64.2147,
    transform: "translate(-36.4094 87.9002) rotate(-45)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "d",
    width: 106.7528,
    height: 106.7528,
    patternTransform: "translate(144.844 380.0913) rotate(-45)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 106.753 106.753"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106.7528,
    height: 106.7528
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "7.876 105.943 5.139 110.462 9.29 113.662 7.876 105.943"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "46.762 115.651 48.598 105.955 53.018 112.638"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "73.327 97.295 77.498 96.202 74.936 105.048 82.82 102.982 75.95 114.903"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 89.6456,
    y1: 111.4862,
    x2: 85.0229,
    y2: 107.156
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "100.7 108.771 101.999 115.644 104.277 107.454"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 65.606,
    y1: 113.9494,
    x2: 64.2432,
    y2: 106.6928
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 112.5773,
    y1: 64.3425,
    x2: 107.744,
    y2: 59.7056
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "100.556 90.138 112.577 93.056 106.567 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "5.883 20.287 8.111 11.307 13.58 16.116"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "27.441 16.866 22.464 16.608 22.319 19.409 17.341 19.151 17.196 21.952 13.15 18.934 11.913 22.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "6.139 82.134 10.379 84.753 11.853 82.367 16.093 84.986 17.567 82.6 19.664 87.192 22.699 84.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 41.7356,
    y1: 10.0519,
    x2: 43.8812,
    y2: 5.415
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 77.4353,
    y1: 49.6401,
    x2: 79.5808,
    y2: 45.0032
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 21.1106,
    y1: 12.6193,
    x2: 20.2272,
    y2: 9.5092
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 28.6978,
    y1: 13.192,
    x2: 27.4142,
    y2: 10.4276
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 62.4688,
    y1: 55.7816,
    x2: 65.016,
    y2: 54.1078
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "36.803 10.947 35.357 16.064 42.7 13.505"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "31.819 20.752 32.124 24.388 26.745 23.021 31.819 20.752"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "8.876 29.307 8.876 31.866 11.546 31.866 10.211 35.76 14.419 36.428"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "75.475 40.52 77.867 41.428 78.814 38.931 81.982 41.56 84.098 37.863"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 22.1052,
    y1: 32.5893,
    x2: 15.43,
    y2: 26.5816
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 27.8423,
    y1: 84.0098,
    x2: 24.2697,
    y2: 75.7705
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 23.1165,
    y1: 28.8623,
    x2: 31.0155,
    y2: 30.3086
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "38.779 19.973 44.12 19.083 42.451 22.421 48.904 21.387"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "37.444 24.638 37.426 29.578 40.949 28.213 42.548 33.5 48.33 28.86 48.835 32.665"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "54.28 56.54 55.397 61.352 58.512 59.215 61.282 63.994 65.844 58.151 67.209 61.739"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "28.902 34.994 37.357 38.906 22.242 40.508"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "18.169 39.631 11.647 41.158 19.677 47.322"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 10.2903,
    y1: 46.5125,
    x2: 6.1619,
    y2: 45.2984
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 35.4578,
    y1: 79.8603,
    x2: 31.3294,
    y2: 78.6462
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "12.226 51.959 18.419 51.076 16.082 55.069 23.677 56.595"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "25.523 45.298 30.459 47.322 27.066 48.905 32.017 50.432 30.409 55.831 33.762 56.595"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "51.378 8.732 60.343 7.137 58.362 13.053 64.124 13.053 63.427 17.447 72.751 16.435"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 50.4965,
    y1: 13.0643,
    x2: 52.0179,
    y2: 17.9735
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 52.1109,
    y1: 23.4041,
    x2: 62.9502,
    y2: 21.7365
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "55.926 27.22 55.926 37.997 62.194 31.611"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 44.6997,
    y1: 39.6312,
    x2: 50.4965,
    y2: 36.5211
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 37.3569,
    y1: 43.4764,
    x2: 40.7502,
    y2: 47.3217
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "47.427 48.905 46.632 44.268 53.16 45.905 53.16 42.465 61.336 43.476 61.336 39.631"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "65.588 27.972 72.412 29.307 66.725 33.98 76.203 34.994"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 69.9478,
    y1: 24.1371,
    x2: 70.7506,
    y2: 20.1845
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "73.138 9.002 68.971 7.456 73.032 4.015 73.138 9.002"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "10.29 61.232 10.29 67.453 14.419 65.869 10.29 61.232"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 20.6689,
    y1: 61.2324,
    x2: 28.056,
    y2: 62.8158
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "23.767 66.23 17.934 68.355 19.448 74.586 10.83 74.245"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 7.2261,
    y1: 71.2375,
    x2: 5.1619,
    y2: 76.2533
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 5.8245,
    y1: 64.3425,
    x2: 0.9913,
    y2: 59.7056
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "28.048 73.057 30.8 68.431 32.994 74.225 34.782 63.811 38.358 68.463 38.377 63.826 43.832 63.057"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "41.028 58.179 42.808 52.674 50.497 62.816"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "50.16 53.945 50.984 50.542 56.901 50.836"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 58.9014,
    y1: 47.905,
    x2: 64.588,
    y2: 49.9469
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "69.474 40.508 70.349 51.076 73.549 50.432 69.474 40.508"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "79.357 32.608 83.217 30.309 76.203 25.721 80.786 23.133 75.066 19.151"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 79.1413,
    y1: 15.6912,
    x2: 84.3541,
    y2: 14.8633
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "80.786 7.009 75.066 13.444 88.829 7.009"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "44.747 68.325 41.057 76.105 52.468 66.074"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "54.95 71.09 52.468 78.253 61.336 79.86 54.95 71.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 61.3359,
    y1: 68.0896,
    x2: 68.1287,
    y2: 68.0896
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "44.7 79.86 42.808 91.232 37.357 83.325"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "33.394 86.663 32.124 93.491 26.745 91.985 25.27 99.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 22.6689,
    y1: 92.9013,
    x2: 17.43,
    y2: 97.4452
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "7.72 101.284 10.513 90.709 16.097 107.439"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "7.876 105.399 5.139 109.917 9.29 113.118 7.876 105.399"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "7.876 -0.81 5.139 3.709 9.29 6.909 7.876 -0.81"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 20.6689,
    y1: 101.3989,
    x2: 19.677,
    y2: 106.6705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "25.27 103.093 28.842 106.671 30.409 103.093 34.937 106.671 35.688 97.445 43.842 106.671"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 41.0283,
    y1: 96.1273,
    x2: 46.6325,
    y2: 99.1396
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "48.26 83.136 49.113 89.192 54.761 84.134 53.16 94.056 59.089 90.103 61.336 99.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 48.2598,
    y1: 94.0563,
    x2: 50.4965,
    y2: 101.3989
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "56.916 100.14 54.16 107.671 57.531 107.671 56.916 100.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "83.217 19.151 90.646 20.185 86.931 10.563"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "92.981 7.009 91.474 11.432 97.837 14.863 94.656 23.967 99.708 24.388 98.817 32.589"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "102.7 19.799 105.524 11.432 108.16 22.161 102.7 19.799"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 95.8374,
    y1: 9.006,
    x2: 98.6998,
    y2: 7.1729
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "103.43 27.22 107.854 29.585 100.7 37.751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 88.8292,
    y1: 27.2196,
    x2: 84.3541,
    y2: 23.9671
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 93.5454,
    y1: 26.5816,
    x2: 90.6456,
    y2: 34.9943
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "88.829 46.512 86.592 34.994 97.123 51.076"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "92.21 37.751 96.318 37.751 96.318 41.56 102.582 43.035 100.7 47.322 107.007 49.926"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 107.0069,
    y1: 37.7511,
    x2: 106.1596,
    y2: 44.2681
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "83.217 47.322 81.947 51.883 90.646 49.926"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "70.091 55.519 76.596 54.572 75.599 61.569 81.693 59.882 81.439 64.812 88.514 65.355"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 84.0978,
    y1: 56.5955,
    x2: 90.6456,
    y2: 56.5955
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "93.545 53.836 97.123 63.267 88.829 61.437"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "98.472 56.248 102.814 51.599 107.257 56.852 98.472 56.248"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "102.582 62.024 106.583 67.631 98.139 69.204 102.361 73.237 90.646 76.77 93.545 85.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "97.837 80.89 103.43 78.646 106.16 83.136"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 107.0069,
    y1: 73.2375,
    x2: 107.8541,
    y2: 76.7705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "73.549 66.016 79.786 67.334 70.349 73.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "65.588 72.475 64.742 76.253 70.349 76.86 65.588 82.01 75.066 82.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 59.9014,
    y1: 85.0098,
    x2: 67.1045,
    y2: 89.192
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "66.861 93.618 75.668 87.794 67.988 104.404"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 64.7424,
    y1: 99.3989,
    x2: 61.3359,
    y2: 104.6705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "46.762 115.955 48.598 106.258 53.018 112.942"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "46.762 8.898 48.598 -0.798 53.018 5.885"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "77.469 74.77 86.931 70.028 78.508 79.819"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 92.9759,
    y1: 71.0896,
    x2: 92.21,
    y2: 66.9936
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 82.2167,
    y1: 79.8186,
    x2: 87.8292,
    y2: 78.8914
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "78.508 84.663 86.297 83.546 84.098 92.056 78.508 84.663"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "73.327 -9.458 77.498 -10.55 74.936 -1.705 82.82 -3.77 75.95 8.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "73.327 97.707 77.498 96.614 74.936 105.46 82.82 103.394 75.95 115.315"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "84.354 99.14 86.931 96.99 91.474 102.905"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "90.646 94.056 90.646 89.192 96.016 91.624 98.614 84.134 101.999 86.663 101.999 84.134"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "100.7 90.138 112.721 93.056 106.71 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "-6.196 90.138 5.825 93.056 -0.186 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "93.545 97.931 98.614 95.173 98.139 102.905 106.16 102.058 104.277 105.258 110.515 106.671"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 104.2769,
    y1: 96.4452,
    x2: 109.3603,
    y2: 96.4452
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 89.6456,
    y1: 111.4862,
    x2: 85.0229,
    y2: 107.156
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 89.6456,
    y1: 4.7335,
    x2: 85.0229,
    y2: 0.4032
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 89.5917,
    y1: 106.2585,
    x2: 98.1395,
    y2: 107.6705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "100.7 2.019 101.999 8.891 104.277 0.701"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "12.354 1.848 16.542 9.289 18.768 3.919"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 65.606,
    y1: 113.9494,
    x2: 64.2432,
    y2: 106.6928
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 65.606,
    y1: 7.1966,
    x2: 64.2432,
    y2: -0.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "23.873 6.711 24.914 0.994 27.184 7.914 32.299 3.376 32.299 9.793 40.408 2.348"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 7.194,
    y1: 24.3885,
    x2: 3.4079,
    y2: 27.9723
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 5.1388,
    y1: 34.9943,
    x2: 6.1619,
    y2: 41.0096
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "7.162 50.926 6.65 56.243 4.408 52.076"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "-4.053 19.799 -1.229 11.432 1.407 22.161 -4.053 19.799"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "-3.323 27.22 1.101 29.585 -6.053 37.751"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "-14.543 37.751 -10.435 37.751 -10.435 41.56 -4.17 43.035 -6.053 47.322 0.254 49.926"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 0.2541,
    y1: 37.7511,
    x2: -0.5931,
    y2: 44.2681
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "-8.281 56.248 -3.939 51.599 0.504 56.852 -8.281 56.248"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "-4.17 62.024 -0.169 67.631 -8.613 69.204 -4.391 73.237 -16.107 76.77 -13.207 85.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "-8.915 80.89 -3.323 78.646 -0.593 83.136"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 0.2541,
    y1: 73.2375,
    x2: 1.1013,
    y2: 76.7705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "-6.053 90.138 5.968 93.056 -0.043 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "-13.207 97.931 -8.138 95.173 -8.613 102.905 -0.593 102.058 -2.476 105.258 3.763 106.671"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: -2.4758,
    y1: 96.4452,
    x2: 2.6075,
    y2: 96.4452
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "7.72 -5.468 10.513 -16.044 16.097 0.686"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "7.876 -1.354 5.139 3.165 9.29 6.365 7.876 -1.354"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 20.6689,
    y1: -5.3539,
    x2: 19.677,
    y2: -0.0822
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "25.27 -3.659 28.842 -0.082 30.409 -3.659 34.937 -0.082 35.688 -9.308 43.842 -0.082"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "56.916 -6.613 54.16 0.918 57.531 0.918 56.916 -6.613"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "46.762 9.202 48.598 -0.494 53.018 6.189"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "73.327 -9.046 77.498 -10.138 74.936 -1.293 82.82 -3.358 75.95 8.562"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "93.545 -8.822 98.614 -11.58 98.139 -3.848 106.16 -4.695 104.277 -1.494 110.515 -0.082"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 89.6456,
    y1: 4.7335,
    x2: 85.0229,
    y2: 0.4032
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 89.5917,
    y1: -0.4943,
    x2: 98.1395,
    y2: 0.9178
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 65.606,
    y1: 7.1966,
    x2: 64.2432,
    y2: -0.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "-13.207 -8.822 -8.138 -11.58 -8.613 -3.848 -0.593 -4.695 -2.476 -1.494 3.763 -0.082"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 65.1969,
    cy: 65.1969,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 65.1969,
    cy: 65.1969,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 65.1969,
    cy: 65.1969,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 65.1969,
    cy: 65.1969,
    r: 57.7278
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 65.195,
    cy: 65.1987,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 65.195,
    cy: 65.1987,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 65.195,
    cy: 65.1987,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 65.195,
    cy: 65.1987,
    r: 57.7278
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "p",
    x1: 20.1507,
    y1: 110.243,
    x2: 110.2393,
    y2: 20.1544
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceCr);
export default __webpack_public_path__ + "static/media/space-CR.6f23375b2e2af73c6c0be4954fe49488.svg";
export { ForwardRef as ReactComponent };